import {Pipe} from "@angular/core";
import * as _ from 'lodash';

@Pipe({
  name: 'orderList'
})
export class OrderListPipe {

  transform(value: any[]): any[] {
    return _.orderBy(value, 'order', ['asc']);
  }

}
